export const categories = [
  {
    id: 1,
    macro: 'Food & Beverages',
    icon: 'food_drinks',
    color: {
      bg: 'bg-red-100',
      text: 'text-red-800',
      border: 'border-red-800',
    },
    micro: [
      {
        id: 101,
        name: 'Fresh Produce & Groceries',
        icon: 'fb_fresh_produce_groceries',
      },
      { id: 102, name: 'Alcoholic Beverages', icon: 'fb_alcoholic_beverages' },
      {
        id: 103,
        name: 'Non-Alcoholic Beverages',
        icon: 'fb_non_alcoholic_beverages',
      },
      {
        id: 104,
        name: 'Packaged & Processed Foods',
        icon: 'fb_packaged_processed_foods',
      },
      { id: 105, name: 'Ethnic Cuisine', icon: 'fb_ethnic_cuisine' },
      {
        id: 106,
        name: 'Health-focused & Organic',
        icon: 'fb_health_focused_organic',
      },
      {
        id: 107,
        name: 'Ready-To-Eat & Frozen Meals',
        icon: 'fb_ready_to_eat_frozen_meals',
      },
      { id: 108, name: 'Street Food', icon: 'fb_street_food' },
      { id: 109, name: 'Desserts & Snacks', icon: 'fb_desserts_snacks' },
      { id: 110, name: 'Food Services', icon: 'fb_food_services' },
    ],
  },
  {
    id: 2,
    macro: 'Fashion and Apparel',
    icon: 'fashion_apparel',
    color: {
      bg: 'bg-green-100',
      text: 'text-green-500',
      border: 'border-green-500',
    },
    micro: [
      {
        id: 201,
        name: 'Casual and Formal Clothing',
        icon: 'fa_casual_formal_clothing',
      },
      { id: 202, name: 'Footwear', icon: 'fa_footwear' },
      { id: 203, name: 'Accessories', icon: 'fa_accessories' },
      { id: 204, name: 'Jewelry', icon: 'fa_jewelry' },
      { id: 205, name: 'Watches', icon: 'fa_watches' },
      { id: 206, name: 'Luxury Items', icon: 'fa_luxury_items' },
      {
        id: 207,
        name: 'Sustainable & Eco-Friendly',
        icon: 'fa_sustainable_eco_friendly',
      },
      { id: 208, name: 'Vintage Clothing', icon: 'fa_vintage_clothing' },
      { id: 209, name: 'Sports & Activewear', icon: 'fa_sports_activewear' },
    ],
  },
  {
    id: 3,
    macro: 'Home & Living',
    icon: 'home_lifestyle',
    color: {
      bg: 'bg-yellow-100',
      text: 'text-yellow-800',
      border: 'border-yellow-800',
    },
    micro: [
      { id: 301, name: 'Home Decor', icon: 'hl_home_decor' },
      { id: 302, name: 'Furniture', icon: 'hl_furniture' },
      { id: 303, name: 'Gardening and Outdoor', icon: 'hl_gardening_outdoor' },
      { id: 304, name: 'Kitchen Essentials', icon: 'hl_kitchen_essentials' },
      { id: 305, name: 'Bedding & Linens', icon: 'hl_bedding_linens' },
      { id: 306, name: 'Home Appliances', icon: 'hl_home_appliances' },
      { id: 307, name: 'Lighting & Fixtures', icon: 'hl_lighting_fixtures' },
      {
        id: 308,
        name: 'Cleaning Products & Services',
        icon: 'hl_cleaning_products_services',
      },
    ],
  },
  {
    id: 4,
    macro: 'Technology & Electronics',
    icon: 'tech_gadgets',
    color: {
      bg: 'bg-purple-100',
      text: 'text-purple-800',
      border: 'border-purple-800',
    },
    micro: [
      {
        id: 401,
        name: 'Consumer Electronics',
        icon: 'tg_consumer_electronics',
      },
      {
        id: 402,
        name: 'Computing & IT Solutions',
        icon: 'tg_computing_it_solutions',
      },
      { id: 403, name: 'Internet & AI', icon: 'tg_internet_ai' },
      { id: 404, name: 'Gaming', icon: 'tg_gaming' },
      {
        id: 405,
        name: 'Smart Home & IoT Devices',
        icon: 'tg_smart_home_iot_devices',
      },
      {
        id: 406,
        name: 'Industrial & Automation Technology',
        icon: 'tg_industrial_automation_technology',
      },
      { id: 407, name: 'Telecommunications', icon: 'tg_telecommunications' },
      { id: 408, name: 'Other Technologies', icon: 'tg_other_technologies' },
    ],
  },
  {
    id: 5,
    macro: 'Arts & Crafts',
    icon: 'arts_crafts',
    color: {
      bg: 'bg-blue-100',
      text: 'text-blue-800',
      border: 'border-blue-800',
    },
    micro: [
      { id: 501, name: 'Paintings & Prints', icon: 'ac_paintings_prints' },
      { id: 502, name: 'Handmade Jewelry', icon: 'ac_handmade_jewelry' },
      { id: 503, name: 'Sculptures', icon: 'ac_sculptures' },
      { id: 504, name: 'Pottery & Ceramics', icon: 'ac_pottery_ceramics' },
      { id: 505, name: 'Textile Arts', icon: 'ac_textile_arts' },
      { id: 506, name: 'DIY', icon: 'ac_diy' },
      { id: 507, name: 'Other Arts', icon: 'ac_other_arts' },
    ],
  },
  {
    id: 6,
    macro: 'Health & Wellness',
    icon: 'health_wellness',
    color: {
      bg: 'bg-green-800/40',
      text: 'text-green-800',
      border: 'border-green-800',
    },
    micro: [
      {
        id: 601,
        name: 'Pharmaceuticals & Medical Devices',
        icon: 'hw_pharmaceuticals_medical_devices',
      },
      { id: 602, name: 'Fitness & Exercise', icon: 'hw_fitness_exercise' },
      {
        id: 603,
        name: 'Personal Care & Hygiene',
        icon: 'hw_personal_care_hygiene',
      },
      {
        id: 604,
        name: 'Nutritional Supplements & Vitamins',
        icon: 'hw_nutritional_supplements_vitamins',
      },
      { id: 605, name: 'Health Services', icon: 'hw_health_services' },
    ],
  },
  {
    id: 7,
    macro: 'Financial & Professional Services',
    icon: 'financial_professional_services',
    color: {
      bg: 'bg-gray-200',
      text: 'text-gray-800',
      border: 'border-gray-800',
    },
    micro: [
      { id: 701, name: 'Banking & Investment', icon: 'fp_banking_investment' },
      { id: 702, name: 'Insurance', icon: 'fp_insurance' },
      { id: 703, name: 'Legal & Consulting', icon: 'fp_legal_consulting' },
      { id: 704, name: 'Accounting & Tax', icon: 'fp_accounting_tax' },
      { id: 705, name: 'Business Solutions', icon: 'fp_business_solutions' },
    ],
  },
  {
    id: 8,
    macro: 'Transportation & Mobility',
    icon: 'transportation_mobility',
    color: {
      bg: 'bg-brick-red/20',
      text: 'text-brick-red',
      border: 'border-brick-red',
    },
    micro: [
      { id: 801, name: 'Personal Vehicles', icon: 'tm_personal_vehicles' },
      {
        id: 802,
        name: 'Public & Shared Transportation',
        icon: 'tm_public_shared_transportation',
      },
      {
        id: 803,
        name: 'Logistics & Courier Services',
        icon: 'tm_logistics_courier_services',
      },
      {
        id: 804,
        name: 'Aviation & Maritime Equipment',
        icon: 'tm_aviation_maritime_equipment',
      },
      {
        id: 805,
        name: 'Vehicle Maintenance & Rental Services',
        icon: 'tm_vehicle_maintenance_rental_services',
      },
    ],
  },
  {
    id: 9,
    macro: 'Education & Entertainment',
    icon: 'education_entertainment',
    color: {
      bg: 'bg-orange-100',
      text: 'text-orange-800',
      border: 'border-orange-800',
    },
    micro: [
      {
        id: 901,
        name: 'Online Learning Platforms & Courses',
        icon: 'ee_online_learning_platforms_courses',
      },
      {
        id: 902,
        name: 'Books & Educational Tools',
        icon: 'ee_books_educational_tools',
      },
      { id: 903, name: 'Movies & Theatre', icon: 'ee_movies_theatre' },
      { id: 904, name: 'Music & Sound', icon: 'ee_music_sound' },
      { id: 905, name: 'Board Games', icon: 'ee_board_games' },
      { id: 906, name: 'Streaming', icon: 'ee_streaming' },
      {
        id: 907,
        name: 'Gaming & Virtual Reality',
        icon: 'ee_gaming_virtual_reality',
      },
      { id: 908, name: 'Travel & Tourism', icon: 'ee_travel_tourism' },
    ],
  },
  {
    id: 10,
    macro: 'Energy & Environment',
    icon: 'energy_environment',
    color: {
      bg: 'bg-blue-900/20',
      text: 'text-blue-800',
      border: 'border-blue-800',
    },
    micro: [
      { id: 1001, name: 'Renewable Energy', icon: 'env_renewable_energy' },
      { id: 1002, name: 'Energy Efficiency', icon: 'env_energy_efficiency' },
      {
        id: 1003,
        name: 'Recycling & Waste Management',
        icon: 'env_recycling_waste_management',
      },
      {
        id: 1004,
        name: 'Electric & Alternative-Fuel Vehicles',
        icon: 'env_electric_alternative_fuel_vehicles',
      },
      {
        id: 1005,
        name: 'Environmental Monitoring & Consulting',
        icon: 'env_environmental_monitoring_consulting',
      },
    ],
  },
  {
    id: 11,
    macro: 'Industrial & Construction',
    icon: 'industrial_construction',
    color: {
      bg: 'bg-pink-100',
      text: 'text-pink-800',
      border: 'border-pink-800',
    },
    micro: [
      {
        id: 1101,
        name: 'Heavy Machinery & Tools',
        icon: 'ic_heavy_machinery_tools',
      },
      {
        id: 1102,
        name: 'Construction Materials & Supplies',
        icon: 'ic_construction_materials_supplies',
      },
      {
        id: 1103,
        name: 'Safety & Protective Equipment',
        icon: 'ic_safety_protective_equipment',
      },
      {
        id: 1104,
        name: 'Industrial Automation & Robotics',
        icon: 'ic_industrial_automation_robotics',
      },
      {
        id: 1105,
        name: 'Engineering & Architectural Services',
        icon: 'ic_engineering_architectural_services',
      },
    ],
  },
  {
    id: 12,
    macro: 'Others',
    icon: 'others',
    color: {
      bg: 'bg-slate-100',
      text: 'text-slate-800',
      border: 'border-slate-800',
    },
    micro: [],
  },
];

/**
 * Category ids are numbers here and in the API. Brands registered before that
 * contract was enforced still store them as strings ("1" / ["109"]).
 *
 * Every lookup in this app matches ids with `===` (the pickers, the taxonomy
 * lookups in the save handlers), so an un-coerced legacy id silently renders as
 * "nothing selected" and then saves back a payload the API rejects with 400.
 * Coerce whenever brand.categories is read into component state.
 */
export const toCategoryId = (v) =>
  typeof v === 'string' && /^\d+$/.test(v.trim()) ? Number(v.trim()) : v;
